import { ServiceProxyMap, createAxiosClient } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/entitlement' }, ServiceProxyMap.PPC_BFF);

interface GetCustomerContactsByEntilementIdsRequest {
  entitlementIds: Array<string>;
  transactionAccountId: string;
}

export const getCustomerContactsBySite = async (requestPayload: GetCustomerContactsByEntilementIdsRequest) => {
  const response = await client.post('/customerContacts/bulk', requestPayload, {
    validateStatus: (status) => status === 200,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};
